import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import brand from './brand.generated.json';
import './styles.css';

document.documentElement.style.setProperty('--primary', brand.theme.primaryDark);
document.documentElement.style.setProperty('--accent', brand.theme.primary);
document.documentElement.style.setProperty('--primary-fg', brand.theme.primaryForeground);
document.documentElement.style.setProperty('--radius', brand.theme.radius);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
